"use strict";

define('evisions/helper/debug',['underscore'], function (_) {
  var EVIHelperDebug = _.extend({
    debug: true,
    debugMessage: function debugMessage() {
      try {
        if (!eviHelperDebug.debug || !window.console && !window.console.firebug) {
          return;
        }
      } catch (e) {
        return;
      }
      try {
        console.log.apply(console, arguments);
      } catch (e) {
        return;
      }
    }
  });
  return EVIHelperDebug;
});

